import { useSnackbar } from 'notistack';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { InvoiceService } from 'api';
const useRequestPaymentLink = invoice => {
  const {
    t
  } = useTranslation();
  const {
    enqueueSnackbar
  } = useSnackbar();
  const [paymentLinkIsLoading, setPaymentLinkIsLoading] = useState(false);
  const requestPaymentLink = async () => {
    if (!invoice || !invoice.invoiceNumber) return;
    const {
      invoiceNumber
    } = invoice;
    setPaymentLinkIsLoading(true);
    try {
      const response = await InvoiceService.requestPaymentLink({
        invoiceNumber: invoiceNumber
      });
      if (response && typeof response === 'string') {
        window.open(response, '_blank', 'noopener,noreferrer,');
      } else {
        throw new Error('Payment link not found in response');
      }
    } catch (e) {
      console.error(e);
      const message = t('error.request_payment_link');
      enqueueSnackbar(message, {
        variant: 'error'
      });
    } finally {
      setPaymentLinkIsLoading(false);
    }
  };
  return {
    requestPaymentLink,
    paymentLinkIsLoading
  };
};
export default useRequestPaymentLink;